import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Hidden } from '@material-ui/core';
import { DividerSection } from '../../../global/components/layout/divider-section';
import { TcsmStates } from '../../../root/tcsm-model';
import { ClergyBioSettings } from '../../arc/models/arc-epi-props';
import { ClergyBioChurchMinistries, ClergyBioMiscellaneous, ClergyBioPosition, DataState, ClergyBioRoutes } from '../model/clergy-bio-app-models';
import ClergyBioComponentLoader from '../components/clergy-bio-component-loader';
import { sortTableStyles } from '../../../global/constants/theme/styles/tables/generic-sort-table';
import { ContentSpacer } from '../../../global/components/layout/generic-content-spacer';
import { WysiwygWithReactLink } from '../../../global/components/wysiwyg-with-react-link';
import { buttonStyles } from '../../../global/constants/theme/styles/components/buttonstyles';
import { ClericIcon } from '../../account-info/components/cleric-indicator';
import { headerIconStyles } from '../../../global/constants/theme/styles/components/header-icon-styles';

interface Props {
	settings: ClergyBioSettings;
	basePath: string;
}

function ClergyBioMinistriesReview(props: Props) {
	const tableClasses = sortTableStyles();
	const { settings, basePath } = props;
	const loadingState = useSelector<TcsmStates, DataState>(state => state?.clergyBioState?.loaded?.ministries);
	const ministries = useSelector<TcsmStates, ClergyBioChurchMinistries>(state => state?.clergyBioState?.ministries);
	const buttonClasses = buttonStyles();
	const headerClasses = headerIconStyles();

	function Labels() {
		return (
			<Hidden xsDown>
				<div className='sort-table-row'>
					<div className='sort-table-row-cell'><p><strong>{settings?.startLabel}</strong></p></div>
					<div className='sort-table-row-cell'><p><strong>{settings?.endLabel}</strong></p></div>
					<div className='sort-table-row-cell'><p><strong>{settings?.institutionLabel}</strong></p></div>
					<div className='sort-table-row-cell'><p><strong>{settings?.positionLabel}</strong></p></div>
				</div>
			</Hidden>
		);
	}

	function TableRow(p: ClergyBioPosition | ClergyBioMiscellaneous, institution: string) {
		return (
			<div className='sort-table-row' key={p?.id} >
				<div className='sort-table-row-cell'>
					<Hidden smUp>
						<p><strong>{settings?.startLabel}</strong></p>
					</Hidden>
					<p>{p?.dateBegan}</p></div>
				<div className='sort-table-row-cell'>
					<Hidden smUp>
						<p><strong>{settings?.endLabel}</strong></p>
					</Hidden>
					<p>{p?.dateEnded}</p></div>
				<div className='sort-table-row-cell'>
					<Hidden smUp>
						<p><strong>{settings?.institutionLabel}</strong></p>
					</Hidden>
					<p>{institution}</p></div>
				<div className='sort-table-row-cell'>
					<Hidden smUp>
						<p><strong>{settings?.positionLabel}</strong></p>
					</Hidden>
					<p>{p?.position}</p></div>
			</div>
		);
	}
	function RenderContent() {
		return (
			<>
				<div className={headerClasses.iconHeader}>
					<ClericIcon />
					<h3>{settings?.stipeTitle}</h3>
				</div>
				<ContentSpacer>
					{
						ministries?.stipendiary?.details?.length > 0 ?
							<div className={tableClasses.sortTable}>
								<Labels />
								<div className='sort-table-content'>
									{
										ministries?.stipendiary?.details?.map(d => d?.positions?.map(p => TableRow(p, `${d?.institutionInfo?.name} ${d?.institutionInfo?.location}`)))
									}
								</div>
							</div> :
							<WysiwygWithReactLink content={settings?.noInformationText} />
					}
				</ContentSpacer>
				<div className={headerClasses.iconHeader}>
					<ClericIcon />
					<h3>{settings?.nonStipeTitle}</h3>
				</div>
				<ContentSpacer>
					{
						ministries?.nonStipendiary?.details?.length > 0 ?
							<div className={tableClasses.sortTable}>
								<Labels />
								<div className='sort-table-content'>
									{
										ministries?.nonStipendiary?.details?.map(d => d?.positions?.map(p => TableRow(p, `${d?.institutionInfo?.name} ${d?.institutionInfo?.location}`)))
									}
								</div>
							</div>
							:
							<WysiwygWithReactLink content={settings?.noInformationText} />
					}
				</ContentSpacer>
				<div className={headerClasses.iconHeader}>
					<ClericIcon />
					<h3>{settings?.miscellaneousTitle}</h3>
				</div>
				<ContentSpacer>
					{
						ministries?.miscellaneous?.details?.length > 0 ?
							<div className={tableClasses.sortTable}>
								<Labels />
								<div className='sort-table-content'>
									{
										ministries?.miscellaneous?.details?.map(d => TableRow(d, d?.institutionInfo))
									}
								</div>
							</div>
							:
							<WysiwygWithReactLink content={settings?.noInformationText} />
					}
				</ContentSpacer>
			</>
		);
	}

	return (
		<DividerSection sectionText={settings?.ministryTitle} >
			<ClergyBioComponentLoader
				state={loadingState}
				content={<RenderContent />}
			/>
			<ContentSpacer>
				<Link className={buttonClasses.primaryButton} to={`${basePath}${ClergyBioRoutes.Ministry}`}>{settings?.updateButtonText}</Link>
			</ContentSpacer>
		</DividerSection>
	);
}


export default ClergyBioMinistriesReview;